import { ActivityEntrySchema } from '@contracts/schemas/activity.schema';
import { pageOf } from '@contracts/schemas/common.schema';
import type {
  ActivityFilter,
  ActivityPage,
  ActivityRepository,
} from '@/application/ports/ActivityRepository';
import { request } from '../client';

const ActivityPageSchema = pageOf(ActivityEntrySchema);

export class HttpActivityRepository implements ActivityRepository {
  async list(filter: ActivityFilter): Promise<ActivityPage> {
    const params = new URLSearchParams();
    for (const key of ['userId', 'type', 'from', 'to', 'target', 'jobOrderNo'] as const) {
      const value = filter[key];
      if (value !== undefined && value !== '' && value !== 'all') params.set(key, value);
    }
    if (filter.page !== undefined) params.set('page', String(filter.page));
    if (filter.pageSize !== undefined) params.set('pageSize', String(filter.pageSize));

    const search = params.toString();
    return request(`/activity${search === '' ? '' : `?${search}`}`, {
      schema: ActivityPageSchema,
    });
  }

  async forCase(jobOrderNo: string, page = 1, pageSize = 200): Promise<ActivityPage> {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    return request(`/job-orders/${encodeURIComponent(jobOrderNo)}/activity?${params.toString()}`, {
      schema: ActivityPageSchema,
    });
  }
}
